export type LifeState = {
  life: LifeObject
} & LifeActions

export interface LifeObject {
  code: string
  proposalNumber: string
  planType: string
  productType: string
  planPrice: string
  paymentMeans: string
  productId: string
  cancellation: LifeCancellationFlow
}

export interface LifeActions {
  setLifeObject: (life: LifeObject) => void
  setLifeCancellation: (lifeCancellation: LifeCancellationFlow) => void
  setLifeCancellationReasonCode: (cancellationReasonCode: number) => void
  setLifeCancellationReasons: (cancellationReasons: LifeCancellationReason[]) => void
  setLifeCancellationTerms: (isTermsAndConditionsAccepted: boolean) => void
  setLifeCancellationReceipt: (receipt: LifeCancellationResponse) => void
  resetLife: () => void
}

export interface LifeCancellationResponse {
  message: string
}

export interface LifeCancellationReason {
  Code: number
  Description: string
}

export interface LifeCancellationFlow {
  isTermsAndConditionsAccepted: boolean
  reasonCode: number
  reasons: LifeCancellationReason[]
  receipt: LifeCancellationResponse
}

export const INITIAL_STATE: LifeObject = {
  code: '',
  proposalNumber: '',
  productType: '',
  productId: '',
  planType: '',
  planPrice: '',
  paymentMeans: '',
  cancellation: {
    isTermsAndConditionsAccepted: false,
    reasonCode: 0,
    reasons: [],
    receipt: {
      message: '',
    },
  },
}
